import { render } from "./Huolto.vue?vue&type=template&id=27fa8aaf&ts=true"
import script from "./Huolto.vue?vue&type=script&lang=ts"
export * from "./Huolto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__